import React from 'react';

import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import styled, { css } from 'styled-components';

import CloseButton from '~/shared/components/CloseButton';
import { Button, mobile } from '~/techstyle-shared/react-components';
import { FormattedMessage, useIntl } from '~/techstyle-shared/react-intl';

import ProductDetailCTAModal from '../ProductDetailCTAModal';

const messages = defineMessages({
  modalTitle: {
    id: 'global_cta.waitlist_modal_title',
    defaultMessage: 'fabletics waitlist modal',
  },
});

const sideProductImageStyles = css`
  display: none;
`;

const WaitlistMessage = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.waitlistModalMessage};
  line-height: 1.5;
`;

const WaitlistEmailOption = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.sublabelBlack};
  line-height: 1.5;
`;

const WaitlistButton = styled(Button)`
  background: ${({ theme }) => theme.colors.sublabelBlack};
  border: ${({ theme }) => theme.colors.sublabelBlack};
  margin: 24px 0 16px;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  border-radius: 4px;
  ${mobile` 
    margin-top: 16px;
  `}
`;

const ModalCloseButton = styled(CloseButton)`
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 18px;
`;

export default function WaitlistModal({
  dialogProps,
  isPlusSizeSelected,
  isLoading,
  onCTAClick,
  ...rest
}) {
  const intl = useIntl();
  const closeLabel = intl.formatMessage({
    id: 'global_cta.close',
    defaultMessage: 'Close',
  });

  return (
    <ProductDetailCTAModal
      dialogProps={dialogProps}
      isPlusSizeSelected={isPlusSizeSelected}
      title={intl.formatMessage(messages.modalTitle)}
      showPrices
      sideProductImageStyles={sideProductImageStyles}
      closeButton={
        <ModalCloseButton
          aria-label={closeLabel}
          data-autotag="pdp_waitlist_Modal_Close_btn"
        />
      }
      {...rest}
    >
      <WaitlistEmailOption>
        <FormattedMessage
          id="site_memberlist.email_me"
          defaultMessage="Email Me"
        />
      </WaitlistEmailOption>
      <WaitlistMessage>
        <FormattedMessage
          id="site_memberlist.we_email"
          defaultMessage="We'll send you an email when this item comes back in stock"
        />
      </WaitlistMessage>
      <WaitlistButton
        onClick={onCTAClick}
        isLoading={isLoading}
        data-autotag="pdp_waitlist_confirm_btn"
      >
        <FormattedMessage
          id="site_memberlist.confirm"
          defaultMessage="Confirm"
        />
      </WaitlistButton>
    </ProductDetailCTAModal>
  );
}

WaitlistModal.propTypes = {
  dialogProps: PropTypes.object,
  isLoading: PropTypes.bool,
  isPlusSizeSelected: PropTypes.bool,
  onCTAClick: PropTypes.func,
};
